import MuiBox, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { BaseBoxProps } from './interface';
import React from 'react';
import { colorStringToPalette } from '@src/utils/colorStringToPalette/colorStringToPalette';

const BORDER_MAPPING = {
  borderWidth: 'border',
  borderLeftWidth: 'borderLeft',
  borderRightWidth: 'borderRight',
  borderTopWidth: 'borderTop',
  borderBottomWidth: 'borderBottom',
};

export const BaseBox = (props: BaseBoxProps) => {
  return <MuiBox {...medelyPropsToMuiProps(props)} />;
};

const medelyBorderToMuiBorder = (width: number, style?: string) => {
  // For ui-kit we've decided to split borderStyle and borderWidth into separate props.
  // Howerver they're a single prop in MUI. This will convert the ui-kit border prop to the correct value for MUI.
  if (!!style) {
    return `${width}px ${style}`;
  }
  return width;
};

type SxPropsForMuiBox = {
  borderColor?: string;
  opacity?: number;
};

const medelyPropsToMuiProps = ({
  alignContent = 'flex-start', // Default to flex-start to match mobile
  ...props
}: BaseBoxProps): MuiBoxProps => {
  const muiProps: MuiBoxProps = { ...props, alignContent };
  const sx = {
    opacity: props.opacity,
  } as SxPropsForMuiBox;

  Object.keys(BORDER_MAPPING).forEach((k) => {
    const key = k as keyof typeof BORDER_MAPPING;
    const width = props[key] as number;
    if (!!width) {
      const muiKey = BORDER_MAPPING[key] as keyof MuiBoxProps;
      muiProps[muiKey] = medelyBorderToMuiBorder(width, props.borderStyle);
    }
  });

  if (!!props.bgcolor) {
    muiProps.bgcolor = colorStringToPalette(props.bgcolor);
  }
  if (!!props.borderColor) {
    // Set borderColor in sx because it could inconsistently apply depending on the order of the props.
    delete muiProps.borderColor;
    sx.borderColor = colorStringToPalette(props.borderColor);
  }

  return {
    sx,
    ...muiProps,
  };
};
